<p-dialog
  [header]="'misc.sharedPopUp.header' | transloco"
  [(visible)]="dialogVisible"
  (onShow)="this.openDialog()"
  [blockScroll]="false"
  [style]="{width: '40vw'}" [modal]="true" [draggable]="false"
  (visibleChange)="onVisibleChange($event)">
  <hr class="mt-0">
  <div class="flex flex-column">
    <div class="form-field col-12">
      <label for="emails">{{'attribute.email' | transloco}}(s):</label>
    </div>
    <div *ngIf="this.loadingSharedEmails || this.loadingUserEmail" class="col-12">
      <p-skeleton width="100%" height="2.5rem"></p-skeleton>
    </div>
    <div *ngIf="!this.loadingSharedEmails && !this.loadingUserEmail" class="col-12">
      <p-autoComplete [(ngModel)]="emailsToShare" [suggestions]="emailSuggestions" (completeMethod)="search($event)"
                      [multiple]="true" id="emails" styleClass="w-full" appendTo="body"
                      [placeholder]="'misc.sharedPopUp.hint' | transloco" (onSelect)="selectEmail($event)"
                      (onUnselect)="unselectEmail($event)" [autofocus]="true">
        <ng-template let-entityEmail pTemplate="item">
          <div class="flex align-items-center">
            <div class="entity-circle big-circle p-2 flex align-items-center">
              <i *ngIf="entityEmail.entityType === 'USER'" class="pi pi-user big-icon"></i>
              <i *ngIf="entityEmail.entityType === 'TENANT'" class="pi pi-briefcase big-icon"></i>
              <i *ngIf="entityEmail.entityType === 'ORGANIZATION'" class="pi pi-sitemap big-icon"></i>
            </div>
            <div class="mb-0 ml-3 p-0">
              <span class="font-medium">{{entityEmail.name}}</span><br>
              <span class="text-xs">{{entityEmail.email}}</span>
            </div>
          </div>
        </ng-template>
        <ng-template let-entityEmail pTemplate="selectedItem">
          <div class="m-0 flex align-items-center" style="border-radius: 50%">
            <div class="entity-circle p-2">
              <i *ngIf="entityEmail.entityType === 'USER'" class="pi pi-user"></i>
              <i *ngIf="entityEmail.entityType === 'TENANT'" class="pi pi-briefcase"></i>
              <i *ngIf="entityEmail.entityType === 'ORGANIZATION'" class="pi pi-sitemap"></i>
            </div>
            <p class="mb-0 ml-1 p-0">{{entityEmail.email}}</p>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>
    <div *ngIf="sharedWithEmails?.length > 0" class="flex flex-row mt-4 ml-2 align-items-center">
      <span class="block font-semibold text-lg mr-2 align-self-center">{{'misc.sharedPopUp.sharedWith' | transloco}}</span>
      <div *ngFor="let sharedEmail of sharedWithEmails; let i = index">
        <div *ngIf="i < maxSharedEmails" class="entity-circle p-2 mr-2" pTooltip="{{sharedEmail.name}}<br/>{{sharedEmail.email}}"
             tooltipPosition="top" tooltipStyleClass="circle-tooltip">
          <i *ngIf="sharedEmail.entityType === 'USER'" class="pi pi-user"></i>
          <i *ngIf="sharedEmail.entityType === 'TENANT'" class="pi pi-briefcase"></i>
          <i *ngIf="sharedEmail.entityType === 'ORGANIZATION'" class="pi pi-sitemap"></i>
        </div>
      </div>
      <div *ngIf="sharedWithEmails?.length > maxSharedEmails">
        <span class="ml-1">{{'misc.sharedPopUp.andMore' | transloco: {number: sharedWithEmails?.length - maxSharedEmails} }}</span>
      </div>
    </div>
    <div class="flex flex-column justify-content-between mt-3">
      <div class="flex flex-column md:flex-row justify-content-end" style="padding-right: 0.5rem;">
        <p-button (onClick)="clearList()" styleClass="p-button-secondary" [disabled]="persistingChanges"
                  [label]="'misc.sharedPopUp.clearList' | transloco">
        </p-button>
        <p-button class="ml-2" [loading]="persistingChanges" styleClass="p-button-primary"
                  (onClick)="shareResource()" [label]="'misc.sharedPopUp.share' | transloco">
        </p-button>
      </div>
    </div>
  </div>
</p-dialog>

